export const FormsActionTypes = {
  API_RESPONSE_SUCCESS: '@@formularios-internos/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@formularios-internos/API_RESPONSE_ERROR',

  GET_FORM: '@@formularios-internos/GET_FORM',
  LIST_FORMS: '@@formularios-internos/LIST_FORMS',
  ADD_FORM: '@@formularios-internos/ADD_FORM',
  UPDATE_FORM: '@@formularios-internos/UPDATE_FORM',
  DELETE_FORM: '@@formularios-internos/DELETE_FORM',

  RESET: '@@formularios-internos/RESET'
}
